import { atom, useAtom } from "jotai";
import { State } from "./State";
import { fetchBase } from "./BaseApi";

export type Check = {
  checkId: number;
  checkText:string;
  moneySupportComment: string;
  expectedSupportComment: string;
};

export type Job = {
  jobName: string;
  avgEducationFee: number;
  avgSalary: number;
};

export type PrepareContent = {
  // --- 親子カテゴリー関連 ---
  childParentCategory: string;    // A/B/C/D
  educationMin: number;
  educationAvg: number;
  educationMax: number;
  educationSample: number;
  educationGap: number;
  incomeMin: number;
  incomeMax: number;
  monthlyInvestmentFrom:number;
  monthlyInvestmentTo:number;
  jobList: Job[];
  parentComment: string;
  childComment: string;
  childFinancialShortComment: string;
  childFinancialLongComment: string;
  lifeLevelCategory: string;     // L1/L2/L3
  retiredMin: number;
  retiredAvg: number;
  retiredMax: number;
  retiredSample: number;
  retiredGap: number;
  monthlyExpenditureFrom:number;
  monthlyExpenditureTo:number;
  lifeLevelComment: string;
  leisureLevelComment: string;
  lifeFinancialShortComment: string; 
  lifeFinancialLongComment: string;
  lifePrepareComment:string;
  categoryImage: string; // 画像データ
  checkList: Check[];
};

const unregisteredUri = "api/unregistered-users/user-prepare";
const uri             = "api/users/user-prepare";

export const fetchPrepareContentAtom = atom<State<PrepareContent> | null>(null);
export const fetchPrepareContent = () => {
    return fetchBase<PrepareContent>(uri, fetchPrepareContentAtom);
};
export const fetchUnregisteredPrepareContent = () => {
    return fetchBase<PrepareContent>(unregisteredUri, fetchPrepareContentAtom);
};

